import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useMst } from "@store/Route";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import "./Child.scss";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import { AlertSuccess } from "@utils/alert";
import BlackProfile from "@img/icons/blankProfile.png";
import { toJS } from "mobx";
import CardChild from "./components/CardChild";

const Child = observer(() => {
  const history = useHistory();
  const { students, landing, schedulePermissions, childs } = useMst();
  const { token, userId } = landing;

  const {
    getListChilds,
    listChildren,
    fetchingListChild,
    paginationListChild,
    initialState,
    removePermission,
  } = schedulePermissions;

  const { setChildSelected } = childs;

  const getStudentsData = (pageNumber: number) => {
    if (token && userId) {
      getListChilds(token, userId, pageNumber);
    }
  };

  useEffect(() => {
    getStudentsData(1);
  }, []);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    getStudentsData(value);
  };

  return (
    <section className="ManageChild">
      <div className="mt-10 w-full justify-end mb-4 flex flex-row">
        <ButtonLoader
          onClick={() => {
            history.push("/dashboard/manage/child/add");
          }}
          type="button"
          className={"w-72"}
        >
          Add Child
        </ButtonLoader>
      </div>
      <div className="bg-white p-10 rounded-lg">
        <section>
          {fetchingListChild === "pending" ? (
            <div className="loaderWrapper">
              <div className="preloader preloaderBus" />
            </div>
          ) : listChildren && listChildren.length > 0 ? (
            listChildren.map((item, index) => {
              return (
                <CardChild
                  item={item}
                  key={item.id}
                  getStudentsData={getStudentsData}
                  index={index}
                ></CardChild>
              );
            })
          ) : (
            <div className="ChildItem__mainWrapper">
              <div className="row no-gutters">
                <p className="offset-3 col-6 text-center header--16 color--blue">
                  You no have any child.
                </p>
              </div>
            </div>
          )}
        </section>
      </div>

      {paginationListChild?.totalPages ? (
        <div className="mt-6 bg-white p-2 rounded-2xl flex justify-center w-full">
          <Pagination
            count={paginationListChild.totalPages}
            defaultPage={1}
            siblingCount={0}
            boundaryCount={2}
            onChange={handleChangePage}
            size="large"
            page={paginationListChild.currentPage}
            className={"w-full flex justify-center"}
          />
        </div>
      ) : null}
    </section>
  );
});

export default Child;
